import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getQuery = async (id: number) => {
  const { data, error } = await supabase
    .from('trading_platforms')
    .select('*')
    .eq('id', id)
    .single()

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export default function useGetTradingPlatformById(id: number) {
  return useQuery({
    queryKey: ['useGetTradingPlatformById'],
    queryFn: () => getQuery(id),
    staleTime: 0,
    cacheTime: 0,
    enabled: !!id,
  })
}
